import React, { useContext, useEffect, useReducer } from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

var toastContext = React.createContext([{ toastMessages: [] }, function () { return []; }]);

var e=[],t=[];function injector_3614a569(n,r){if(n&&"undefined"!=typeof document){void 0===r&&(r={});var d,a=!0===r.prepend?"prepend":"append",i="undefined"!=typeof r.singleTag&&r.singleTag,s="undefined"!=typeof r.container?document.querySelector(r.container):document.getElementsByTagName("head")[0];if(i){var u=e.indexOf(s);-1===u&&(u=e.push(s)-1,t[u]={}),d=t[u]&&t[u][a]?t[u][a]:t[u][a]=o();}else d=o();65279===n.charCodeAt(0)&&(n=n.substring(1)),d.styleSheet?d.styleSheet.cssText+=n:d.appendChild(document.createTextNode(n));}function o(){var e=document.createElement("style");if(e.setAttribute("type","text/css"),r.attributes)for(var t=Object.keys(r.attributes),n=0;n<t.length;n++)e.setAttribute(t[n],r.attributes[t[n]]);var d="prepend"===a?"afterbegin":"beforeend";return s.insertAdjacentElement(d,e),e}}

const css_d54e0d4e = ".toast-container {\n  position: fixed;\n  min-width: 20rem;\n  right: -18rem;\n  top: 1.5rem;\n  z-index: 1000;\n}\n\n.toast-message {\n  transition: all 0.5s ease;\n  outline: none;\n  max-height: 0px;\n  padding: 0px;\n  margin: 0px;\n  overflow: hidden;\n  border-radius: 0.25rem;\n  border-width: 2px;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),\n    0 10px 10px -5px rgba(0, 0, 0, 0.04);\n}\n\n.toast-enter-active {\n  transform: translateX(-100%);\n  max-height: 5rem;\n  padding: 0.75rem;\n  margin: 0.5rem;\n}\n.toast-enter-done {\n  transform: translateX(-100%);\n  max-height: 5rem;\n  padding: 0.75rem;\n  margin: 0.5rem;\n}\n.toast-exit {\n  transform: translateX(-100%);\n  max-height: 5rem;\n  padding: 0.75rem;\n  margin: 0.5rem;\n}\n.toast-exit-active {\n  transform: translateX(0%);\n}\n";
injector_3614a569(css_d54e0d4e);

function ToastMessageComponent(_a) {
    var _b = _a.animationTimeInMs, animationTimeInMs = _b === void 0 ? 500 : _b;
    var _c = useContext(toastContext), toastMessages = _c[0].toastMessages, dispatch = _c[1];
    var handleClickMsgClear = function (event) {
        if (!(event.currentTarget instanceof HTMLDivElement)) {
            return;
        }
        var _a = event.currentTarget, _b = (_a === void 0 ? {} : _a).dataset, _c = (_b === void 0 ? {} : _b).timestamp, timestamp = _c === void 0 ? "" : _c;
        if (timestamp) {
            dispatch({ type: "clearMsg", data: timestamp });
        }
    };
    useEffect(function () {
        var eventListener = function (event) {
            var dispathMessage = event.detail;
            dispatch(dispathMessage);
        };
        window.addEventListener("react-toaster-minimal-event", eventListener);
        return function () {
            window.removeEventListener("react-toaster-minimal-event", eventListener);
        };
        // eslint-disable-next-line
    }, []);
    return (React.createElement("aside", { className: "toast-container" },
        React.createElement(TransitionGroup, null, toastMessages.map(function (message) {
            return (React.createElement(CSSTransition, { key: message.timestamp, classNames: "toast", timeout: { enter: animationTimeInMs, exit: animationTimeInMs } },
                React.createElement("div", { className: "toast-message", style: __assign({ color: message.textColor || "black", backgroundColor: message.bgColor || "white" }, (message.compStyle || {})), "data-timestamp": message.timestamp, onClick: handleClickMsgClear, tabIndex: -1, role: "button", onKeyPress: handleClickMsgClear },
                    React.createElement("div", null, message.title),
                    message.subTitle && (React.createElement("div", { style: { fontSize: "0.75rem" } }, message.subTitle)))));
        }))));
}

var DEFAULT_TOAST_MESSAGE_TIME_MS = 5000;
var useToast = function () {
    var _a = useContext(toastContext), dispatch = _a[1];
    var showToast = function (message) {
        var timestamp = Date.now();
        dispatch({
            type: "toastMsgs",
            data: __assign({ timestamp: timestamp }, message),
        });
        setTimeout(function () {
            dispatch({ type: "clearMsg", data: timestamp });
        }, message.closeTimeInMs || DEFAULT_TOAST_MESSAGE_TIME_MS);
    };
    return showToast;
};
var showToast = function (message) {
    var timestamp = Date.now();
    var toastEvent = new CustomEvent("react-toaster-minimal-event", {
        detail: {
            type: "toastMsgs",
            data: __assign({ timestamp: timestamp }, message),
        },
    });
    window.dispatchEvent(toastEvent);
    setTimeout(function () {
        var tEvent = new CustomEvent("react-toaster-minimal-event", {
            detail: { type: "clearMsg", data: timestamp },
        });
        window.dispatchEvent(tEvent);
    }, message.closeTimeInMs || DEFAULT_TOAST_MESSAGE_TIME_MS);
};
var reducer = function (state, action) {
    switch (action.type) {
        case "toastMsgs": {
            return {
                toastMessages: __spreadArrays([action.data], state.toastMessages),
            };
        }
        case "clearMsg": {
            var remaingToastMsgs = state.toastMessages.filter(function (message) { return message.timestamp !== +action.data; });
            return { toastMessages: remaingToastMsgs };
        }
        // no default
    }
    return state;
};
function ToastProvider(_a) {
    var _b = _a.children, children = _b === void 0 ? null : _b, animationTimeInMs = _a.animationTimeInMs;
    var context = useReducer(reducer, { toastMessages: [] });
    var Provider = toastContext.Provider;
    return (React.createElement(React.Fragment, null,
        React.createElement(Provider, { value: context },
            React.createElement(ToastMessageComponent, { animationTimeInMs: animationTimeInMs }),
            children)));
}

export default ToastProvider;
export { showToast, useToast };
